import {
  parseCompleteProfilePhotoUploadRequest,
  parseCreateViewerProfilePhotoUploadSessionRequest,
  parseProfilePhotoUploadSessionResponse,
  parseStudentProfilePhotoResponse,
  parseViewerProfilePhotoResponse,
  type ProfilePhotoDto,
  type ViewerProfilePhotoContext
} from "@madamuh/domain";
import { apiGet, apiPost } from "./client";

export async function fetchViewerProfilePhoto(tenantSlug: string, viewerContext: ViewerProfilePhotoContext) {
  return parseViewerProfilePhotoResponse(await apiGet(`/api/v1/app/tenants/${tenantSlug}/me/profile-photo?viewerContext=${viewerContext}`));
}
export async function fetchStudentProfilePhoto(tenantSlug: string, studentId: string) {
  return parseStudentProfilePhotoResponse(await apiGet(`/api/v1/app/tenants/${tenantSlug}/students/${studentId}/profile-photo`));
}
export async function setViewerProfilePhoto(tenantSlug: string, viewerContext: ViewerProfilePhotoContext, blob: Blob): Promise<ProfilePhotoDto> {
  const request = parseCreateViewerProfilePhotoUploadSessionRequest({ viewerContext, mimeType: "image/jpeg", fileSizeBytes: blob.size });
  const session = parseProfilePhotoUploadSessionResponse(await apiPost(`/api/v1/app/tenants/${tenantSlug}/me/profile-photo/upload-session`, request));
  await uploadProfilePhotoBlob(session.uploadUrl, session.requiredHeaders, blob);
  const completed = parseCompleteProfilePhotoUploadRequest({ uploadId: session.uploadId, uploadSessionToken: session.uploadSessionToken });
  const result = parseViewerProfilePhotoResponse(await apiPost(`/api/v1/app/tenants/${tenantSlug}/me/profile-photo/complete`, completed));
  if (!result.profilePhoto) throw new Error("写真の設定に失敗しました。もう一度お試しください。");
  return result.profilePhoto;
}
export async function setStudentProfilePhoto(tenantSlug: string, studentId: string, blob: Blob): Promise<ProfilePhotoDto> {
  const request = { mimeType: "image/jpeg", fileSizeBytes: blob.size };
  const session = parseProfilePhotoUploadSessionResponse(await apiPost(`/api/v1/app/tenants/${tenantSlug}/students/${studentId}/profile-photo/upload-session`, request));
  await uploadProfilePhotoBlob(session.uploadUrl, session.requiredHeaders, blob);
  const completed = parseCompleteProfilePhotoUploadRequest({ uploadId: session.uploadId, uploadSessionToken: session.uploadSessionToken });
  const result = parseStudentProfilePhotoResponse(await apiPost(`/api/v1/app/tenants/${tenantSlug}/students/${studentId}/profile-photo/complete`, completed));
  if (!result.profilePhoto) throw new Error("写真の設定に失敗しました。もう一度お試しください。");
  return result.profilePhoto;
}
export async function uploadProfilePhotoBlob(uploadUrl: string, requiredHeaders: Record<string, string>, blob: Blob) {
  try {
    const response = await fetch(uploadUrl, { method: "PUT", headers: requiredHeaders, body: blob });
    if (!response.ok) throw new Error("upload failed");
  } catch { throw new Error("写真のアップロードに失敗しました。通信環境を確認して、もう一度お試しください。"); }
}
